import React, { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

const KEY = "compeni_cookie_consent";

export function CookieBanner() {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  useEffect(() => {
    try { setShow(!localStorage.getItem(KEY)); } catch { setShow(false); }
  }, []);
  const decide = (v) => {
    try { localStorage.setItem(KEY, v); } catch (err) { console.warn("Cookie consent could not be stored:", err); }
    setShow(false);
  };
  if (!show) return null;
  return (
    <div data-testid="cookie-banner" className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:max-w-md z-[60] animate-fade-up">
      <div className="card-milled rounded-[0.9rem] shadow-float p-5">
        <div className="flex items-start gap-3">
          <span className="grid place-items-center w-9 h-9 rounded-lg bg-primary/10 text-primary shrink-0"><Cookie size={17} strokeWidth={1.75} /></span>
          <div>
            <p className="text-sm font-medium text-foreground">{t("marketing.cookie.title")}</p>
            <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
              {t("marketing.cookie.body")}{" "}
              <Link to="/privacy" className="text-primary hover:underline">{t("marketing.footerPrivacyPolicy")}</Link>.
            </p>
          </div>
        </div>
        <div className="flex gap-2 justify-end mt-4">
          <Button data-testid="cookie-essential" variant="outline" size="sm" className="rounded-lg bg-card" onClick={() => decide("essential")}>{t("marketing.cookie.essential")}</Button>
          <Button data-testid="cookie-accept" size="sm" className="rounded-lg" onClick={() => decide("all")}>{t("marketing.cookie.acceptAll")}</Button>
        </div>
      </div>
    </div>
  );
}
